import raw from 'data/iso3166-countries.json'

export type IsoCountryRow = {name: string; 'alpha-2': string}

const rows = raw as IsoCountryRow[]

export const COUNTRY_SELECT_OPTIONS = [...rows]
  .map((r) => ({code: r['alpha-2'], name: r.name}))
  .sort((a, b) => a.name.localeCompare(b.name, 'en'))

export const ISO3166_ALPHA2_CODES = COUNTRY_SELECT_OPTIONS.map((o) => o.code)

const LEGACY_COUNTRY = new Map<string, string>([
  ['bg', 'BG'],
  ['българия', 'BG'],
  ['bulgaria', 'BG'],
])

/**
 * Map stored DB value (ISO-2 or legacy full name) to uppercase ISO-3166 alpha-2 for the form.
 */
export function countryCodeFromStored(
  stored: string | null | undefined,
  fallback = 'BG',
): string {
  if (!stored?.trim()) {
    return fallback
  }
  const t = stored.trim()
  if (t.length === 2 && /^[A-Za-z]{2}$/.test(t)) {
    return t.toUpperCase()
  }
  const mapped = LEGACY_COUNTRY.get(t.toLowerCase())
  return mapped ?? fallback
}
